import {
  TimeBlockDataDocument,
  TimeBlockDataQuery,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ReimbursableSupplementTaxonomyMapping } from './useFetchReimbursableSupplementMappings'

export type TimeSettingsCustomTimeRangeCategory = NonNullable<
  NonNullable<TimeBlockDataQuery['timeSettings']>['customTimeRangeCategoriesConnection']
>['nodes'][number]

interface QueyResults {
  loading: boolean
  mappings: ReimbursableSupplementTaxonomyMapping[]
  customTimeRangeCategories: TimeSettingsCustomTimeRangeCategory[]
}

export function useFetchTimeBlockData(): QueyResults {
  const { company } = useCurrentSession()
  const lEIds = company.legalEntities.map((l) => l.id)
  const { data: data, loading } = useQuery(TimeBlockDataDocument, {
    variables: {
      legalEntityIds: lEIds,
      companyId: company.id,
    },
  })

  return {
    loading,
    mappings: data?.payroll.reimbursableSupplementTaxonomies ?? [],
    customTimeRangeCategories: data?.timeSettings.customTimeRangeCategoriesConnection.nodes ?? [],
  }
}
